import { render, staticRenderFns } from "./answerBox.vue?vue&type=template&id=5be8f9a5&scoped=true"
import script from "./answerBox.vue?vue&type=script&lang=js"
export * from "./answerBox.vue?vue&type=script&lang=js"
import style0 from "./answerBox.vue?vue&type=style&index=0&id=5be8f9a5&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be8f9a5",
  null
  
)

export default component.exports